import React, { memo } from 'react';

import { Switch } from 'antd';
import classNames from 'classnames';

import { useConfigPanelStore } from '@core/app/stores/configPanel';
import { useLayerStore } from '@core/app/stores/layer/layerStore';
import history from '@core/app/svgedit/history/history';
import undoManager from '@core/app/svgedit/history/undoManager';
import { writeData } from '@core/helpers/layer/layer-config-helper';

import styles from '../Block.module.scss';
import initState from '../initState';
import NumberBlock from '../NumberBlock';

const CuringOptions = memo(({ type = 'default' }: { type?: 'default' | 'modal' | 'panel-item' }) => {
  const { change, uvCuringAfter } = useConfigPanelStore();
  const selectedLayers = useLayerStore((state) => state.selectedLayers);
  const handleToggle = () => {
    const newVal = !uvCuringAfter.value;

    change({ uvCuringAfter: newVal });

    const batchCmd = new history.BatchCommand('Change Curing After toggle');

    selectedLayers.forEach((layerName) => writeData(layerName, 'uvCuringAfter', newVal, { batchCmd }));
    batchCmd.onAfter = initState;
    undoManager.addCommandToHistory(batchCmd);
  };

  return (
    <>
      <div className={classNames(styles.panel, styles.switch)}>
        <label className={styles.title} htmlFor="uv-curing-after">
          Curing After Print
        </label>
        <Switch
          checked={uvCuringAfter.value}
          className={styles.switch}
          id="uv-curing-after"
          onChange={handleToggle}
          size="small"
        />
      </div>
      {uvCuringAfter.value && (
        <>
          <NumberBlock
            configKey="uvPrintingRepeat"
            id="uvPrintingRepeat"
            max={100}
            min={0}
            title="UV Printing Repeat"
            type={type}
          />
          <NumberBlock
            configKey="uvCuringRepeat"
            id="uvCuringRepeat"
            max={100}
            min={1}
            title="UV Curing Repeat"
            type={type}
          />
        </>
      )}
    </>
  );
});

export default CuringOptions;
